<template>
    <div class="modal fade" id="createNewChat" role="dialog">
      <div class="modal-dialog modal-dialog-md">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h2 class="certa first-title">Nova Conversa</h2>
          </div>

          <div v-if="loadingModal" class="modal-body modal-chat">
            <!-- Loading -->
            <div class="loading center_vertical">
              <div class="loader-mini-box">
                <div class="spinner-box">
                  <div class="rect1"></div>
                  <div class="rect2"></div>
                  <div class="rect3"></div>
                  <div class="rect4"></div>
                  <div class="rect5"></div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="!loadingModal" class="modal-body modal-chat">

            <form v-if="dataChat.canSearch">
              <div class="form-group input-blue">
                <p class="nunito default-text">Digite o nome ou e-mail.</p>
                <autocomplete
                  id="myAutocomplete"
                  anchor="name"
                  label="writer"
                  v-bind:url="urlSearchEmp"
                  v-model="userSelected"
                  :customHeaders="{Authorization: 'bearer ' + bearerAutoComplete, Contentsetting: this.contentSetting, DeviceId: browserId, uId: userJsonInfo.id, cId: userJsonInfo.companyId, Up: userJsonInfo.id + userJsonInfo.companyId}"
                  :customParams="{i: userJsonInfo.id}"
                  :min="1"
                  :debounce="500"
                  :onAjaxProgress="callbackEvent"
                  :onAjaxLoaded="callbackEvent"
                  :on-select="getDataSelected">
                </autocomplete>
                <span v-if="error" class="error-msg-modal">{{error}}</span>
              </div>
            </form>

            <div v-else class="list-user-select">
              <p>{{dataChat.text}}</p>
              <div v-for="u in dataChat.list" class="users" v-bind:class="{'selected-user': u.id === userDataChatSelected.id}" v-on:click="userDataChatSelected = u">
                <img v-if="u.photo" v-bind:src="u.photo" class="img-fluid img-circle" alt="user">
                <img v-else src="../../../assets/img/user-default.png" class="img-fluid" alt="user">

                <p class="nunito">{{u.name}}<i class="fa fa-chevron-right" aria-hidden="true"></i></p>
              </div>
            </div>
          </div>

          <div v-if="!loadingModal" class="modal-footer offset-top-20">
            <button v-if="dataChat.canSearch && dataChat.list && dataChat.list.length" v-on:click="sendOpenChat()" :disabled="loadingRequest" v-bind:class="{'disable': loadingRequest}" type="submit" class="nunito btn-yellow-save">
              <span v-if="!loadingRequest">Iniciar Conversa</span>
              <div class="loading-btn" v-else>
                <div class="spinner-btn">
                  <div class="rect1"></div>
                  <div class="rect2"></div>
                  <div class="rect3"></div>
                  <div class="rect4"></div>
                  <div class="rect5"></div>
                </div>
              </div>
            </button>
            <button v-if="!dataChat.canSearch && dataChat.list.length && Object.keys(this.userDataChatSelected).length" v-on:click="sendOpenChatByList()" :disabled="loadingChange" v-bind:class="{'disable': loadingChange}" type="submit" class="nunito btn-yellow-save">
              <span v-if="!loadingChange">Iniciar Conversa</span>
              <div class="loading-btn" v-else>
                <div class="spinner-btn">
                  <div class="rect1"></div>
                  <div class="rect2"></div>
                  <div class="rect3"></div>
                  <div class="rect4"></div>
                  <div class="rect5"></div>
                </div>
              </div>
            </button>
            <button v-on:click="closeModal()" class="nunito close-btn">Fechar</button>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  import { HAS_OPENED_CHAT, SEARCH_USER_CHAT, CHECK_SEARCH_USER } from "../../../urlConfig";
  import { REQUEST_SERVICE } from "../../../requestConfig";
  import { UTIL_SERVICE } from "../../../utils";
  import Autocomplete from 'vue2-autocomplete-js'
  import modalAlert from "./modalAlert";

  export default {
    name: "perfil-change-linkedin",
    components: {
      Autocomplete,
      modalAlert
    },
    props:['callCheckList'],
    data() {
      return {
        userJsonInfo: JSON.parse(window.localStorage.getItem('userInfo')),
        authJsonInfo: JSON.parse(window.localStorage.getItem('authUser')),
        browserId: JSON.parse(window.localStorage.getItem('browserId')),
        dataChat: {},
        userDataChatSelected: {},
        userInfo: {},
        urlSearchEmp: SEARCH_USER_CHAT,
        bearerAutoComplete: JSON.parse(window.localStorage.getItem('authUser')).userToken,
        contentSetting: JSON.parse(window.localStorage.getItem('authUser')).userContentSetting,
        userSelected: '',
        resultCheckChat: '',
        error: '',
        loadingModal: false,
        loadingChange: false,
        loadingRequest: false,
        emitValue: {
          resultCheck: '',
          dataUser: '',
          random: ''
        },
      }
    },
    watch: {
      callCheckList: function(val) {
        this.checkListUser();
      },
      emitValue : function(val){
        this.$emit('update:actionOpenNewChat', val)
      }
    },
    methods: {
      checkListUser() {
        this.loadingModal = true;
        REQUEST_SERVICE.get(CHECK_SEARCH_USER + this.userInfo.id).then((response) => {
          UTIL_SERVICE.console("RESULT CHECK_SEARCH_USER:", response.data);

          this.dataChat = response.data;
          this.loadingModal = false;
        }).catch(reason => {
          this.loadingModal = false;
        })
      },
      checkChat(id) {
        this.loadingRequest = true;
        REQUEST_SERVICE.get(HAS_OPENED_CHAT + "?i=" + this.userInfo.companyId + "&recipient=" + id).then((response) => {
          UTIL_SERVICE.console("RESULT HAS_OPENED_CHAT:", response.data);

          this.resultCheckChat = response.data;
          this.loadingRequest = false;
        }).catch(reason => {
          this.loadingRequest = false;
        })
      },
      callbackEvent(value) {

      },
      getDataSelected(obj) {
        console.log(obj)
        this.userSelected = obj;

        this.checkChat(obj.id);
      },
      closeModal() {
        $('#createNewChat').modal('toggle');
      },
      sendOpenChatByList() {
        if(Object.keys(this.userDataChatSelected).length) {
          this.emitValue = {byList: true, resultCheck: this.resultCheckChat, dataUser: this.userDataChatSelected, random: Math.floor(Math.random() * 500)};

          $('#createNewChat').modal('toggle');
        } else {
          this.error = 'Selecione um colaborador para iniciar o chat.'
        }
        
      },
      sendOpenChat() {
        console.log(this.userDataChatSelected)
        this.error = '';
        if (this.userSelected.id) {
          if (this.loadingRequest) {
            setTimeout(function(){
              this.emitValue = {resultCheck: this.resultCheckChat, dataUser: this.userSelected, random: Math.floor(Math.random() * 500)};

              $('#createNewChat').modal('toggle');
            }, 1000);
          } else {
            this.emitValue = {resultCheck: this.resultCheckChat, dataUser: this.userSelected, random: Math.floor(Math.random() * 500)};

            $('#createNewChat').modal('toggle');
          }
        } else {
          this.error = "Campo obrigatório.";
        }
      }
    },
    beforeMount() {
      this.userInfo = UTIL_SERVICE.getStorage('userInfo');
    }
  }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/vue/views/modals/createNewChat.vue